import { KEY } from './constants'

export const SET_BANNER = `${KEY}/SET_BANNER`
export const SET_LOADER = `${KEY}/SET_LOADER`
